// Source: app/scripts/controllers/mfa-audit.js
Auction.controller('MfaAuditController', [
  '$scope',
  '$location',
  'UserService',
  'EntityLogHelpers',
  function ($scope, $location, UserService, EntityLogHelpers) {

    $scope.usernameFilter = $location.search().username || '';
    $scope.mfaLogs = [];
    $scope.isMfaLogEntry = EntityLogHelpers.isMfaLogEntry;
    $scope.formatMfaLogValue = EntityLogHelpers.formatMfaLogValue;

    $scope.loadMfaLogs = function () {
      var params = {};
      if ($scope.usernameFilter && $scope.usernameFilter.trim()) {
        params.code = $scope.usernameFilter.trim();
      }
      UserService.getMfaLog(params, function (logs) {
        $scope.mfaLogs = logs || [];
      });
    };

    $scope.loadMfaLogs();
  }
]);
